<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Add User</h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body pb-0 text-grey" style="overflow: auto;">
  <form
    name="addUserForm"
    [formGroup]="addUserForm"
    (ngSubmit)="onSubmit(addUserForm)"
    autocomplete="off"
    spellcheck="false"
  >
    <mat-dialog-content class="mat-typography">
      <p style="margin-bottom: 0px">Account Details</p>
    </mat-dialog-content>
    <mat-form-field style="width: 32%;">
      <mat-label>User Name</mat-label>
      <input
        matInput
        placeholder="User Name"
        formControlName="addUserUserId"
        title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -"
        style="font-size:14px"
      />
      <mat-error
        *ngIf="
          addUserForm.get('addUserUserId').touched &&
          addUserForm.get('addUserUserId').errors?.required
        "
        style="font-size:14px"
        >Required</mat-error
      >
      <mat-error
        *ngIf="addUserForm.get('addUserUserId').errors?.userNameAlreadyUsed"
        style="font-size:14px"
        >Please Enter Unique UserID.</mat-error
      >
      <mat-error *ngIf="addUserForm.get('addUserUserId').errors?.pattern" style="font-size:14px"
        >Enter valid User Id.</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 32%; margin-left: 2%;">
      <mat-label>Add User Role</mat-label>
      <mat-select formControlName="addUserUserRole" (selectionChange)="optionClicked($event.value)" style="font-size:14px">
        <mat-option *ngFor="let type of types" value="{{ type.value }}">{{
          type.name
        }}</mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          addUserForm.get('addUserUserRole').touched &&
          addUserForm.get('addUserUserRole').errors
        "
        style="font-size:14px"

        >Required</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 32%; margin-left: 2%;">
      <mat-label>Select Deployment</mat-label>
      <mat-select formControlName="addUserDeployment" multiple style="font-size:14px">
        <!-- <mat-option value="None">None</mat-option> -->
        <mat-option *ngFor="let dep of deployments" value="{{ dep.name }}">
          {{
          dep.name
          }}
        </mat-option>
        <mat-option *ngIf="!deployments"
          style="color: #7b7777"
          title="No Deployments are Available."
          disabled>No Deployments Available.</mat-option>
      </mat-select>
      <mat-error *ngIf="
          addUserForm.get('addUserDeployment').touched &&
          addUserForm.get('addUserDeployment').errors
        " style="font-size: smaller">Required</mat-error>
    </mat-form-field>

    <mat-dialog-content class="mat-typography">
      <p style="margin-bottom: 0px">Personal Details</p>
    </mat-dialog-content>
    <mat-form-field style="width: 32%;">
      <mat-label>First Name</mat-label>
      <input
        matInput
        style="font-size:14px"
        placeholder="First Name"
        formControlName="addUserFirstName"
      />
      <mat-error
        *ngIf="
          addUserForm.get('addUserFirstName').touched &&
          addUserForm.get('addUserFirstName').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="
          addUserForm.get('addUserFirstName').touched &&
          addUserForm.get('addUserFirstName').errors?.pattern
        ">Enter Valid Name.</mat-error>
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-left: 2%;">
      <mat-label>Last Name</mat-label>
      <input
        matInput
        style="font-size:14px"
        placeholder="Last Name"
        formControlName="addUserLastName"
      />
      <mat-error
        *ngIf="
          addUserForm.get('addUserLastName').touched &&
          addUserForm.get('addUserLastName').errors?.required
        "
                 style="font-size:smaller">Required</mat-error>
      <mat-error *ngIf="
          addUserForm.get('addUserLastName').touched &&
          addUserForm.get('addUserLastName').errors?.pattern
        ">Enter Valid Name.</mat-error>
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-left: 2%;">
      <mat-label>Email Address</mat-label>
      <input
        matInput
        style="font-size:14px"
        placeholder="Email"
        type="email"
        multiple
        formControlName="addUserEmail"
        title="Add one or multiple comma separated emails."
      />
      <mat-error
        *ngIf="
          addUserForm.get('addUserEmail').touched &&
          addUserForm.get('addUserEmail').errors?.required
        "
                 style="font-size:smaller">Required</mat-error>
      <mat-error *ngIf="
          addUserForm.get('addUserEmail').touched &&
          addUserForm.get('addUserEmail').errors?.pattern
        "
                 style="font-size:smaller">Enter Valid Email.</mat-error>
      <mat-error *ngIf="addUserForm.get('addUserEmail').errors?.emailAlreadyUsed"
                 style="font-size:smaller">Email Id already in use !</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 32%;" *ngIf="addUserToIdentityServer === true">
      <mat-label>Password</mat-label>
      <input
        matInput
        style="font-size:14px"
        [type]="!fieldTextType ? 'text' : 'password'"
        placeholder="Password"
        formControlName="addUserPassword"
             title="Password must be of minimum 8 character containing at least one uppercase, one lowercase, one digit, one special character( _ @ $ )" />
      <mat-icon *ngIf="addUserForm.get('addUserPassword').value != (null || '')"
        (click)="togglePassswordIcon()"
        style="font-size: 100% !important"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType,
          'bi-eye-slash-fill': !fieldTextType
        }"></mat-icon>
      <mat-error *ngIf="
          addUserForm.get('addUserPassword').touched &&
          addUserForm.get('addUserPassword').errors?.required
        "
                 style="font-size:smaller">Required</mat-error>
      <mat-error *ngIf="
          addUserForm.get('addUserPassword').touched &&
          addUserForm.get('addUserPassword').errors?.pattern
        "
                 style="font-size:14px">Enter Valid Password.</mat-error>
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-left: 2%;"
                    *ngIf="addUserToIdentityServer === true">
      <mat-label>Confirm Password</mat-label>
      <input matInput
             style="font-size:14px"
        type="password"
        placeholder="Confirm Password"
             formControlName="addUserConfirmPassword" />
      <mat-error *ngIf="
          addUserForm.get('addUserConfirmPassword').touched &&
          addUserForm.get('addUserConfirmPassword').errors?.required
        "
                 style="font-size:smaller">Required</mat-error>
      <!--<mat-error *ngIf="
          addUserForm.get('addUserConfirmPassword').touched &&
          addUserForm.get('addUserConfirmPassword').errors?.pattern
        "
                 style="font-size:smaller">Enter Valid Password.</mat-error>-->
      <mat-error *ngIf="
          addUserForm.get('addUserConfirmPassword').touched &&
          addUserForm.get('addUserConfirmPassword').errors?.passwordMismatch
        "
                 style="font-size: 14px">Confirm-Passwords must match</mat-error>
    </mat-form-field>

    <br />

    <mat-tab-group>
      <mat-tab label="Public key" class="mat-elevation-z4">
        <ng-container >
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Public Key</mat-label>
            <textarea
              matInput
              formControlName="addUserPublicKey"
              rows="6"
              style="width: 98%; max-width: 98%; resize: none"
            ></textarea>
            <mat-error
              *ngIf="
                addUserForm.get('addUserPublicKey').touched &&
                addUserForm.get('addUserPublicKey').invalid
              "
              >Required.</mat-error
            >
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="User start command"  class="mat-elevation-z4">
        <ng-container >
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>User start command.</mat-label>
            <textarea
              matInput
              cdkFocusInitial
              formControlName="addUserCommand"
              rows="6"
              style="width: 98%; max-width: 98%; resize: none"
              placeholder="Enter user init command which will be executed during job execution."
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="Additional Information"  class="mat-elevation-z4">
        <ng-container >
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Additional User Information (Optional).</mat-label>
            <textarea
              matInput
              cdkFocusInitial
              formControlName="addUserAdditionalInfo"
              rows="6"
              style="width: 98%; max-width: 98%; resize: none"
              placeholder=""
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="Custom UID"  class="mat-elevation-z4">
        <ng-container >
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Custom UID (Optional).</mat-label>
            <textarea
              matInput
              cdkFocusInitial
              formControlName="addUserCustomUid"
              rows="6"
              style="width: 98%; max-width: 98%; resize: none"
              placeholder=""
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="Custom GID"  class="mat-elevation-z4">
        <ng-container >
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Custom GID (Optional).</mat-label>
            <textarea
              matInput
              cdkFocusInitial
              formControlName="addUserCustomGid"
              rows="6"
              style="width: 98%; max-width: 98%; resize: none"
              placeholder=""
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

    
  </form>
</div>
<div class="modal-footer text-grey">
  <div *ngIf="addUserLimitReached">
    <p class="addUserLimitReached" >
      <i class="bi bi-exclamation-lg"></i> Maximum allowed users limit reached.
      No more users can be added.
    </p>
  </div>
  <div *ngIf="globalAdminFlag">
    <p class="addUserLimitReached" >
      <i class="bi bi-exclamation-lg"></i> User with role Global Admin has access to all the things.
    </p>
  </div>
  <div *ngIf="!addUserLimitReached">
    <!-- <mat-error *ngIf="globalAdminFlag">User with role Global Admin has access to all the things.</mat-error> -->
    <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="onClose()"
            >
      Close
    </button>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!addUserForm.valid || !isHeadNodeActive"
      [title]="!addUserForm.valid || !isHeadNodeActive ? 'Submit button will be enabled when all required fields are filled and if Head Node is in Active state.' : 'New user will be added on submitting the form.'"
      (click)="onSubmit(addUserForm)">
      Submit
    </button>
  </div>
</div>
<ngx-spinner
  name="addUser"
  bdColor="rgba(0,0,0,0)"
  size="default" zIndex = "1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  ><p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
